import { OrganizationsInviteState } from '../interfaces';

export function parseOrganizationInviteState(state: string): OrganizationsInviteState {
  return JSON.parse(window.atob(state));
}
